import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody} from '@mui/material';
import { MerchantProviderFee } from '../../../types/reports/merchantProviderFee';

interface Props {
   merchantProviderFees?:MerchantProviderFee[];
   total?: string;
}

enum Types {
    MerchantProviderFee = 319,
    RefundedContribution = 305,
}

const MerchantProviderFeesScheduleTable = (props: Props): JSX.Element => {

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper}>
             <Table aria-label="merchant provider fee table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Date
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Name/Address
                             </Typography>
                         </TableCell>
                         <TableCell align='right'>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Amount
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Type
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Purpose
                             </Typography>
                         </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {props.merchantProviderFees?.map((fee) => (
                         <TableRow
                            key={fee.id}
                         >
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {fee.date}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {fee.fullNameReverse} 
                                 </Typography>
                                 <Typography variant={'subtitle2'}>
                                     {fee.fullAddress} 
                                 </Typography>
                             </TableCell>
                             <TableCell align='right'>
                                 <Typography variant={'subtitle2'}>
                                     {fee.amount}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {fee.recordTypeDescription}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                      {fee.recordTypeId === Types.MerchantProviderFee? fee.description: "CC Contribution Refund via R7"}
                                 </Typography>
                             </TableCell>
                         </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={2}>Total:</TableCell>
                        <TableCell align='right'><b>{props.total}</b></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default MerchantProviderFeesScheduleTable;